<p-dialog [(visible)]="visible" [modal]="true" [closable]="true" [baseZIndex]="10000"
  header="New HERO Report" i18n-header="@@newHeroReportHeader">

  <form [formGroup]="heroReportForm" (ngSubmit)="onSubmit()">
    <app-row>
      <app-input
        label="Coordinates"
        i18n-label="@@coordinatesLabel"
        placeholder="Paste or right click on the map to copy coordinates"
        i18n-placeholder="@@coordinatesPlaceholder"
        [required]="true"
        formControlName="coordinates"
        [touched]="heroReportForm.get('coordinates')?.touched"
        [errorMessage]="heroReportForm.get('coordinates')?.errors">
      </app-input>
    </app-row>

    <app-information-block i18n="Instruction to copy map coordinates@@copyCoordinatesInfo">
      You can right click on the map and <b>Copy Coordinates</b> to your clipboard
    </app-information-block>

    <div style="display: flex; justify-content: space-between; margin-bottom: 20px;">

      <button
        pButton
        label="Cancel"
        i18n-label="@@cancelButton"
        class="p-button-text p-mr-2"
        type="button"
        (click)="onCancel()">
      </button>

      <div style="display: flex; gap: 0.5rem">
        <button
          pButton
          label="Create SRE Report"
          i18n-label="@@createSreReportButton"
          class="p-button-outlined"
          type="button"
          (click)="onSubmit('SRE')"
          [disabled]="heroReportForm.invalid">
        </button>

        <button
          pButton
          label="Create Report"
          i18n-label="@@createReportButton"
          class="p-button-primary"
          type="submit"
          [disabled]="heroReportForm.invalid">
        </button>
      </div>

    </div>
  </form>
</p-dialog>